/* eslint-disable import/prefer-default-export */
import React from 'react';

import { AndroidIcon, AppleIcon } from 'rebook/apps/base/components/icons/appIcon';


const appMetricaUrl = 'https://redirect.appmetrica.yandex.com/serve';

export const APPS = {
  ios: {
    id: 0,
    installUrl: `${appMetricaUrl}/674048688460421021/`,
    slug: 'IOS',
    name: 'iOS',
    icon: <AppleIcon />,
  },
  android: {
    id: 1,
    installUrl: `${appMetricaUrl}/97588024321320240/`,
    slug: 'Android',
    name: 'Android',
    icon: <AndroidIcon />,
  },
};
